
import { Card } from "@/components/ui/card";
import { TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import EmailSettings from "@/components/settings/EmailSettings";
import AIAssistantSettings from "@/components/settings/AIAssistantSettings";
import AccountSettings from "@/components/settings/AccountSettings";
import { TokenManagement } from "@/components/settings/sections/TokenManagement";
import { TokenCostsManagement } from "@/components/settings/sections/TokenCostsManagement";
import { SubscriptionPlans } from "@/components/settings/sections/SubscriptionPlans";

interface SettingsContentProps {
  isAdmin: boolean;
}

export const SettingsContent = ({ isAdmin }: SettingsContentProps) => {
  const navigate = useNavigate();

  return (
    <>
      <TabsContent value="email">
        <Card className="p-6">
          <EmailSettings />
        </Card>
      </TabsContent>

      <TabsContent value="assistants">
        <Card className="p-6">
          <AIAssistantSettings />
        </Card>
      </TabsContent>

      <TabsContent value="tokens">
        <Card className="p-6">
          <TokenManagement />
        </Card>
      </TabsContent>

      <TabsContent value="plans">
        <Card className="p-6">
          <SubscriptionPlans />
        </Card>
      </TabsContent>

      <TabsContent value="account">
        <Card className="p-6">
          <AccountSettings />
          <div className="mt-8 pt-8 border-t">
            <h3 className="text-lg font-semibold mb-4">Additional Resources</h3>
            <Button 
              variant="ghost" 
              className="text-muted-foreground hover:text-foreground"
              onClick={() => navigate('/privacy-policy')}
            >
              Privacy Policy
            </Button>
          </div>
        </Card>
      </TabsContent>

      {isAdmin && (
        <TabsContent value="admin">
          <Card className="p-6">
            <TokenCostsManagement />
          </Card>
        </TabsContent>
      )}
    </>
  );
};
